export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';

export const TURN_CREATE_REQUEST = 'TURN_CREATE_REQUEST';
export const TURN_CREATE_SUCCESS = 'TURN_CREATE_SUCCESS';
export const TURN_CREATE_FAIL = 'TURN_CREATE_FAIL';

export const TURN_DELETE_REQUEST = 'TURN_DELETE_REQUEST';
export const TURN_DELETE_SUCCESS = 'TURN_DELETE_SUCCESS';
export const TURN_DELETE_FAIL = 'TURN_DELETE_FAIL';

export const TURN_GET_REQUEST = 'TURN_GET_REQUEST';
export const TURN_GET_SUCCESS = 'TURN_GET_SUCCESS';
export const TURN_GET_FAIL = 'TURN_GET_FAIL';

export const TURN_UPDATE_REQUEST = 'TURN_UPDATE_REQUEST';
export const TURN_UPDATE_SUCCESS = 'TURN_UPDATE_SUCCESS';
export const TURN_UPDATE_FAIL = 'TURN_UPDATE_FAIL';

export const USER_LOGOUT = 'USER_LOGOUT';

export const EMAIL_VERIFICATION = 'EMAIL_VERIFICATION';
